import { NgModule, ModuleWithProviders  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

import { Constants, Formats, ValidatorExpressions } from './constants';
import { TranslatorService } from './translator.service';
import { ConfigurationService } from './configuration.service';
import { ContextService } from './context.service';
import { AuthGuard } from './auth.guard.service';
import { AuthInterceptor } from './auth.interceptor';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule
  ],
  exports: [
  ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        Constants,
        Formats,
        ValidatorExpressions,
        AuthGuard,
        TranslatorService,
        ConfigurationService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true,
        },
        ContextService
      ]
    };
 }

}
